<template>
  <div class="th_info">
    <div class="th_info_top">{{$t('main.text309')}}</div>
    <div class="th_info_main">
        <div class="th_tit1">{{$t('main.text309')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text310')}}</div>
            <div class="th_tit4">{{overall_time(data_all.c_time)}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text326')}}</div>
            <div class="th_tit4">{{data_all.tx_id}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text338')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text458')}}</div>
            <div class="th_tit4">{{data_all.token_type}} {{set_num3(data_all.amount)}}</div>
        </div>

        <div class="th_tit1 title_bottom">{{$t('main.text340')}}</div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text348')}}</div>
            <div class="th_tit4">{{data_all.address_details.name}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text342')}}</div>
            <div class="th_tit4">{{data_all.address_details.address}}</div>
        </div>
        <div class="th_tit2">
            <div class="th_tit3">{{$t('main.text343')}}</div>
            <div class="th_tit4">{{data_all.address_details.type}}</div>
        </div>
        <div class="th_tit2" v-if="data_all.status==22">
            <!-- <div class="th_tit3">Refuse Reason</div>text489 -->
            <div class="th_tit3">{{$t('main.text489')}}</div>
            <div class="th_tit4">{{ des_fun(data_all.des)}}</div>
        </div>
        
        
    </div>
  </div>
</template>

<script>
import {crypto_get} from '@/api/api';

export default {
    data() {
        return {
            fiat_info_tx_id:'',
            fiat_info_id:'',
            data_all:{
                address_details:{}
            },
        }
    },
    created() {
        this.fiat_info_tx_id=sessionStorage.getItem('fiat_info_tx_id');
        this.fiat_info_id=sessionStorage.getItem('fiat_info_id');
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
        sessionStorage.removeItem('fiat_info_id');
    },
    mounted() {
        if (this.fiat_info_tx_id=='-') {
            sessionStorage.setItem('top_title_name','');
        }else{
            sessionStorage.setItem('top_title_name',this.fiat_info_tx_id);
        }
        this.get_list();
    },
    methods: {
        get_list(){
            crypto_get({id:this.fiat_info_id}).then(res=>{
                if (res.data.code==200) {
                    this.data_all=res.data.data;
                    // console.log(this.data_all);
                }
            })
        },
        des_fun(v){
            if (v) {
                let res;
                v = eval('(' + v + ')')
                if(this.v_lan=='ch'){
                    res = v.reason_ch || '-';
                }else if(this.v_lan=='jp'){
                    res = v.reason_jp || '-';
                }else{
                    res = v.reason_en || '-';
                }
                return res;
            }
        }

    },
}
</script>

<style scoped>
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1px solid #041E35;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 30px;
}
</style>